// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1iJYS","title":"styles_title__3hsqQ"};